import React from 'react';
import PropTypes from 'prop-types';
import { Card, DataLegend, InternalGrid, Text } from '@paygreen/paygreen-ui';
import { IsDesktop, IsMobile } from '../../utils/tools';

const SmallDataCard = (props) => {
    const {
        blockWidth,
        children,
        colorPallet,
        colorTheme,
        colorWab,
        colorStatus,
        icon,
        radiusSize,
        title,
        unit,
        value,
        isDisabled,
    } = props;

    const isMobile = IsMobile();

    let cardIcon = null;

    if (icon) {
        cardIcon = React.cloneElement(icon, {
            iconSize: 'lg',
            colorPallet: colorPallet,
            colorTheme: colorTheme,
            colorWab: colorWab,
            colorStatus: colorStatus,
            marginRight: 'sm',
        });
    }

    return (
        <Card
            colorPallet={colorPallet}
            colorTheme={colorTheme}
            colorWab={colorWab}
            colorStatus={colorStatus}
            shadowSize="none"
            blockWidth={blockWidth}
            paddingLateral={isMobile ? 'none' : 'xs'}
            paddingBottom="xs"
            paddingTop="xs"
            radiusSize={radiusSize}
            className={isDisabled && 'gray-filter'}
            style={{
                minWidth: IsDesktop() ? '200px' : '150px',
            }}
        >
            {title ? (
                <Text align="center" colorWab="grey40" textSize="xs">
                    {title}
                </Text>
            ) : null}

            <InternalGrid
                childrenMarginTop="md"
                childrenMarginBottom="xs"
                justifyContent="center"
            >
                {cardIcon || null}
                <DataLegend
                    textSize="sm"
                    value={value || 0}
                    unit={unit}
                    colorPallet={colorPallet}
                    colorTheme={colorTheme}
                    colorWab={colorWab}
                    colorStatus={colorStatus}
                />
            </InternalGrid>

            <InternalGrid
                childrenMarginTop="md"
                childrenMarginBottom="xs"
                justifyContent="center"
            >
                {children}
            </InternalGrid>
        </Card>
    );
};

SmallDataCard.propTypes = {
    blockWidth: PropTypes.string,
    colorPallet: PropTypes.string,
    colorStatus: PropTypes.string,
    colorTheme: PropTypes.string,
    colorWab: PropTypes.string,
    radiusSize: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.element,
    unit: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SmallDataCard.defaultProps = {
    blockWidth: 'md',
    colorPallet: 'status',
    colorStatus: 'default',
    colorTheme: 'primary',
    colorWab: 'white00',
    radiusSize: 'lg',
    unit: ' ',
    value: 0,
};

export default SmallDataCard;
